import { render, staticRenderFns } from "./yuezhuan.vue?vue&type=template&id=28a33529&scoped=true&"
import script from "./yuezhuan.vue?vue&type=script&lang=js&"
export * from "./yuezhuan.vue?vue&type=script&lang=js&"
import style0 from "./yuezhuan.vue?vue&type=style&index=0&id=28a33529&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a33529",
  null
  
)

export default component.exports